<template>
  <stat-item
    :label="statObj.label"
    :value="statObj.displayValue"
    :success="statObj.success"
    :error="statObj.error"
  />
</template>

<script>
import StatItem from './StatItem';
import { CARD_STAT_FIELDS } from '../constants';

export default {
  components: {
    StatItem,
  },

  props: {
    card: Object,
    stat: String,
  },

  computed: {
    statObj() {
      const stat = CARD_STAT_FIELDS.find((statObj) => statObj.value === this.stat);

      let returnValue = {
        label: '',
        displayValue: '',
      };

      if (stat && stat.value) {
        const statValue = this.card.stats ? this.card.stats[stat.value] || this.card[stat.value] : this.card[stat.value];

        returnValue = {
          ...stat,
          displayValue: statValue,
        };

        if (stat.format === 'string') {
          returnValue.displayValue = statValue;
        } else if (stat.format !== undefined) {
          if (stat.value === 'gap') {
            returnValue.label = statValue < 0 ? 'Overvalued' : 'Undervalued';
            returnValue.displayValue = statValue === undefined ? null : this.$filters[stat.format](Math.abs(statValue), stat.formatOptions);
          } else {
            returnValue.displayValue = this.$filters[stat.format](statValue, stat.formatOptions);
          }

          if (stat.showChange && statValue > 0) {
            returnValue.displayValue = `+${returnValue.displayValue}`;
          }

          if (stat.showChange) {
            if (statValue > 0) {
              returnValue.success = true;
            } else if (statValue < 0) {
              returnValue.error = true;
            }
          }
        }
      }

      return returnValue;
    },
  },
};
</script>
